import { create } from 'zustand';

import { apiListBoardsForProfile } from '../api/boardFetch';
import type { BoardProfileSection } from '../types/boardTypes';

export type ReloadProfileBoardsOptions = {
  canLoad?: boolean;
  onError?: (message: string) => void;
};

type ProfileBoardsState = {
  ownSections: BoardProfileSection[];
  sharedSections: BoardProfileSection[];
  isLoading: boolean;
  isLoaded: boolean;
  reloadBoards: (options?: ReloadProfileBoardsOptions) => Promise<void>;
  resetProfileBoards: () => void;
};

const emptyState = {
  ownSections: [] as BoardProfileSection[],
  sharedSections: [] as BoardProfileSection[],
  isLoading: false,
  isLoaded: false,
};

export const useProfileBoardsStore = create<ProfileBoardsState>((set) => ({
  ...emptyState,

  reloadBoards: async (options = {}) => {
    const { canLoad = true, onError } = options;

    if (!canLoad) {
      set({ ...emptyState, isLoaded: true });
      return;
    }

    set({ isLoading: true });
    try {
      const data = await apiListBoardsForProfile();
      set({
        ownSections: data.own,
        sharedSections: data.shared,
        isLoading: false,
        isLoaded: true,
      });
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Failed to load boards';
      onError?.(message);
      set({
        ownSections: [],
        sharedSections: [],
        isLoading: false,
        isLoaded: true,
      });
    }
  },

  resetProfileBoards: () => set(emptyState),
}));
